import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { capitalize, isMobileUA } from 'dpl/shared/utils';
import { RESULTS_TYPE } from 'dpl/constants/query_params';
import { pushParams, resetParams } from 'dpl/actions/query_params';
import Icon from 'dpl/common/components/Icon';

import { RESULTS_TYPES } from '../utils/constants';

const IS_BOT_UA = window.__DPL_BOT_UA;
const IS_MOBILE_UA = isMobileUA();
const BUTTON_CLASSNAMES =
  'dib col-6 tc transition button--large ba br3 b--light-gray';
const ICON_SIZE = '20px';

function capitalizeIfNoCount(text, count) {
  return IS_BOT_UA || count === null ? capitalize(text) : text;
}

export default function ResultsTypeSelector({
  puppiesCount,
  breedersCount,
  resultsType,
  locked
}) {
  const dispatch = useDispatch();

  const adjustedPuppyCount = puppiesCount > 40 ? '40+' : puppiesCount;
  const adjustedBreederCount = breedersCount > 40 ? '40+' : breedersCount;

  const puppyTabText = IS_MOBILE_UA ? 'puppies' : 'available puppies';
  const breederTabText = IS_MOBILE_UA ? 'breeders' : 'certified breeders';

  return (
    <div className="ResultsTypeSelector overflow-hidden fw-medium font-16-mobile">
      <button
        type="button"
        onClick={() => {
          dispatch(resetParams(RESULTS_TYPE));
          dispatch(
            pushParams(
              { [RESULTS_TYPE]: RESULTS_TYPES.PUPPIES },
              { hash: true }
            )
          );
        }}
        className={classnames(
          BUTTON_CLASSNAMES,
          'ResultsTypePuppies br--left',
          {
            'selected-tab': resultsType === RESULTS_TYPES.PUPPIES,
            'br-0': resultsType !== RESULTS_TYPES.PUPPIES,
            'hover-bg-lightest-purple': !locked
          }
        )}
        disabled={locked}
      >
        <Icon
          className="black dib v-top mr2"
          name="paw"
          height={ICON_SIZE}
          width={ICON_SIZE}
        />
        {!IS_BOT_UA &&
          adjustedPuppyCount &&
          `${adjustedPuppyCount.toLocaleString()}`}{' '}
        {capitalizeIfNoCount(puppyTabText, adjustedPuppyCount)}
      </button>
      <button
        type="button"
        onClick={() => {
          dispatch(
            pushParams(
              { [RESULTS_TYPE]: RESULTS_TYPES.BREEDERS },
              { hash: true }
            )
          );
        }}
        className={classnames(
          BUTTON_CLASSNAMES,
          'ResultsTypeBreeders br--right',
          {
            'selected-tab': resultsType === RESULTS_TYPES.BREEDERS,
            'bl-0': resultsType !== RESULTS_TYPES.BREEDERS,
            'hover-bg-lightest-purple': !locked
          }
        )}
        disabled={locked}
      >
        <Icon
          className="black dib v-top mr2"
          name="certified-badge"
          height={ICON_SIZE}
          width={ICON_SIZE}
        />
        {!IS_BOT_UA &&
          adjustedBreederCount &&
          `${adjustedBreederCount.toLocaleString()}`}{' '}
        {capitalizeIfNoCount(breederTabText, adjustedBreederCount)}
      </button>
    </div>
  );
}

ResultsTypeSelector.propTypes = {
  puppiesCount: PropTypes.number,
  breedersCount: PropTypes.number,
  resultsType: PropTypes.string,
  locked: PropTypes.bool
};

ResultsTypeSelector.defaultProps = {
  puppiesCount: 0,
  breedersCount: 0,
  resultsType: '',
  locked: false
};
